import React from 'react';
import { Link } from 'react-router-dom';
import content from '../data/content.json';
import { resolveAssetPath, sortByOrderThenId } from '../utils/content';

const logos = [...(content.logos ?? [])].sort(sortByOrderThenId);

const LogosPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#0b0b0b', color: '#fff', padding: '100px 5%' }}>
      <Link to="/#Works" style={{ color: '#41b3ff', textDecoration: 'none', marginBottom: '40px', display: 'inline-block' }} />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px' }}>
        {logos.map((logo) => (
          <div
            key={logo.id}
            style={{
              height: '250px',
              background: '#1a1a1a',
              borderRadius: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #333',
              transition: 'transform 0.3s, box-shadow 0.3s, border-color 0.3s',
              cursor: 'pointer',
              overflow: 'hidden'
            }}
            onMouseEnter={(event) => {
              event.currentTarget.style.transform = 'scale(1.05)';
              event.currentTarget.style.boxShadow = '0 0 30px rgba(65, 179, 255, 0.2)';
              event.currentTarget.style.borderColor = '#4fff03ff';
            }}
            onMouseLeave={(event) => {
              event.currentTarget.style.transform = 'scale(1)';
              event.currentTarget.style.boxShadow = 'none';
              event.currentTarget.style.borderColor = '#333';
            }}
          >
            <img
              src={resolveAssetPath(logo.image)}
              alt={logo.title || 'Logo'}
              style={{
                width: '80%',
                height: '80%',
                objectFit: 'contain'
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogosPage;
